import React from "react";
import "./styles.scss";

const Reports = () => {
  return <>Reports</>;
};

export default Reports;
